import type { StyleSpecification } from "mapbox-gl";

/** Minimal basemap with no network tile requests — used when offline. */
export const OFFLINE_MAP_STYLE: StyleSpecification = {
  version: 8,
  name: "ruumi-offline",
  sources: {},
  layers: [
    {
      id: "background",
      type: "background",
      paint: {
        "background-color": "#e8e4dc",
      },
    },
  ],
};

export const ONLINE_MAP_STYLE = "mapbox://styles/mapbox/satellite-streets-v12";

/** Solid field polygons (no satellite overlay) on mobile and when offline. */
export function shouldUseSolidFieldFills(
  isMobile: boolean,
  online: boolean
): boolean {
  return isMobile || !online;
}

// Always use the Mapbox satellite style — the SW tile cache serves cached tiles
// when offline, so there's no need to fall back to a blank local style.
export function getMapStyleForConnectivity(
  _online: boolean
): string | StyleSpecification {
  return ONLINE_MAP_STYLE;
}
